import BroadcastService from '/@/integrations/pusher/BroadcastService';
import { getters, commits } from '/@/modules/core/app/helpers/store';
import { BaseService } from '/@/modules/core/app/services/abstracts/BaseService';
import { NewMessageUserSocketEvent } from '@/modules/messenger/_modules/conversation/events/NewMessageUserSocketEvent';
import { InboxEvent } from '/@/modules/inbox/constants/InboxEvent';
import InboxConversationService from '/@/modules/inbox/services/InboxConversationService';
import EventBus from '/@/modules/core/app/helpers/EventBus';

export class InboxBackgroundService extends BaseService {
  /**
   * @var {?AuthUser}
   */
  authUser;

  /**
   * @param {?AuthUser} authUser
   */
  async initialize(authUser) {
    if (!authUser) {
      return;
    }

    this.authUser = authUser;
    BroadcastService.listen(NewMessageUserSocketEvent, this.onNewMessage, authUser.id);
    await InboxConversationService.getUnreadConversations();
  }

  async onNewMessage({ conversationId, isDeleted }) {
    if (isDeleted) {
      commits.inbox.removeUnreadConversation(conversationId);
      return;
    }

    const conversation = await InboxConversationService.getConversation(conversationId);
    if (!conversation) {
      return;
    }

    commits.inbox.addUnreadConversation(conversation);
    EventBus.signal(InboxEvent.ON_UNREAD_CHANGED, getters.inbox.getUnreadConversations());
  }

  /**
   * @param {AuthUser} authUser
   */
  reInitialize(authUser) {
    this.reset();
    this.initialize(authUser);
  }

  reset() {
    BroadcastService.stopListening(NewMessageUserSocketEvent, undefined, this.authUser.id);
    commits.inbox.setUnreadConversations([]);
    this.authUser = null;
  }
}

export default new InboxBackgroundService();
